import * as yup from 'yup';

export const formSchema = yup.object().shape({
  comboOfferName: yup
    .string()
    .nullable()
    .required('combo offer name is required'),
  uploadedComboImage: yup
    .mixed()
    .test(
      'fileSize',
      'Please attach image size upto 200KB',
      (file) => {
        if (!file) return true;
        return (file as File)?.size <= 200 * 1000;
      }
    ),
  discountTypeOption: yup
    .string()
    .nullable()
    .required()
    .default('PERCENT'),
  discountFundedBy: yup
    .number()
    .nullable()
    .required('select discount funded by'),
  plantCodes: yup
    .array(yup.string().required())
    .nullable()
    .required('select at least one plant'),
  discountValue: yup
    .number()
    .nullable()
    .required('discount value is required')
    .typeError('please enter a number'),
  startDate: yup
    .date()
    .required('Start Date is required')
    .min(new Date(), 'Start Date should not be in past'),
  endDate: yup
    .date()
    .required('End Date is required')
    .min(new Date(), 'End Date should not be in past'),
  productSelection: yup.array(yup.number().required()),
  comboItemDTOList: yup
    .array(
      yup
        .object({
          productId: yup
            .number()
            .nullable()
            .required('please select a product')
            .typeError('A number is required'),
          quantity: yup
            .number()
            .nullable()
            .min(1, 'quantity should not less than 1')
            .required('quantity is required')
            .typeError('A number is required'),
        })
        .required()
    )
    .required(
      'Please add at least one product for discount'
    )
    .min(1, 'Please add at least one product for discount'),
});

export type TFormDataComboOffer = yup.InferType<
  typeof formSchema
>;
